import "./index.css";
import App from "./App";
import React from "react";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { AppContextProvider } from "./redux/context";
import { ClerkProvider } from "@clerk/react";
import { CLERK_PUBLISHABLE_KEY } from "./auth/clerkConfig";
import ClerkBridge from "./auth/ClerkBridge";

// Stripe.js is loaded only when a payment form opens (StripePayment.jsx),
// so no Stripe script or widget runs on the rest of the site.

const root = ReactDOM.createRoot(document.getElementById("root"));
const tree = (
  <Provider store={store}>
    <AppContextProvider>
      {CLERK_PUBLISHABLE_KEY && <ClerkBridge />}
      <App />
    </AppContextProvider>
  </Provider>
);
root.render(
  CLERK_PUBLISHABLE_KEY ? <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>{tree}</ClerkProvider> : tree
);

reportWebVitals();
